module.exports = __webpack_public_path__ + "img/70.57b20e3e.jpg";